import { Signatory } from "@/type/core/dashboard/dashboard.types";
import { SignaturePicture } from "@/type/core/signatory/signatory.types";
import configuration from "@/utils/Config";
import {
  restDetailsHandler,
  restGetHandler,
  restUpdateHandlerWithParams,
} from "@/utils/rest/RestClient";
import { createEffect } from "effector";
import { SearchSignatoryCertificateRequestDto } from "@state/signatory/request/search.signatory.certificate.request.dto";
import { SearchSignatoryPatternRequestDto } from "@state/signatory/request/search.signatory.pattern.request.dto";
import { SearchSignatoryPictureRequestDto } from "@state/signatory/request/search.signatory.picture.request.dto";
import { SearchSignatoryCertificateResponseDto } from "@state/signatory/response/search.signatory.certificate.response.dto";
import { SearchSignatoryPatternResponseDto } from "@state/signatory/response/search.signatory.pattern.response.dto";

const baseUrl = configuration.backendBaseUrl;
const signatoryUrl = baseUrl + "/ws/fo/signatory";
const signatoryPictureSearchUrl = signatoryUrl + "/picture/search";
const signatoryPatternSearchUrl = signatoryUrl + "/pattern/search";
const signatoryCertificateSearchUrl = signatoryUrl + "/certificate/search";
const isEditableUrl = "/isEditable";

export const requestSearchSignatoryPicture = createEffect({
  handler: restGetHandler<SignaturePicture, SearchSignatoryPictureRequestDto>(
    signatoryPictureSearchUrl,
  ),
});

export const requestSearchSignatoryPattern = createEffect({
  handler: restGetHandler<
    SearchSignatoryPatternResponseDto,
    SearchSignatoryPatternRequestDto
  >(signatoryPatternSearchUrl),
});

export const requestSearchSignatoryCertificate = createEffect({
  handler: restGetHandler<
    SearchSignatoryCertificateResponseDto,
    SearchSignatoryCertificateRequestDto
  >(signatoryCertificateSearchUrl),
});

export const requestSignatoryIsEditable = createEffect({
  handler: restDetailsHandler<boolean>(signatoryUrl, isEditableUrl),
});

export const requestUpdateSignatory = createEffect({
  handler: restUpdateHandlerWithParams<
    Pick<Signatory, "firstname" | "lastname" | "email" | "phone" | "id">,
    Signatory
  >(signatoryUrl),
});
